<!--
 * @Author: yujing
 * @Date: 2019-10-29 14:13:35
 * @Description: 
 * @LastEditTime: 2019-10-29 15:32:05
 -->
<template>
  <div
    :style="[
                mysrc
                    ? {
                        backgroundImage: 'url(' + mysrc + ')',
                        backgroundSize: model,
                    }
                    : '',
                style,
            ]"
    class="image-container"
  >
    <div class="ipt">
      <el-input placeholder="请输入关键词" v-model="keyValue" class="input-with-select">
        <el-button slot="append" icon="el-icon-search" @click="serchImg"></el-button>
      </el-input>
    </div>
    <slot />
  </div>
</template>

<script>
// copied from offital Vue examples
export default {
    props: {
        width: {
            type: Number,
            default: 0
        },
        heigth: {
            type: Number,
            default: 0
        },
        src: {
            type: String,
            required: true
        },
        model: {
            type: String,
            default: "contain"
        }
    },
    data() {
        return {
            keyValue:"",
        };
    },
    computed: {
        style() {
            let style = {};

            if (this.width) {
                style.width = this.width + "px";
                let heigth = this.heigth;
                if (!this.height) {
                    heigth = this.width;
                }
                style.height = heigth + "px";
            }
            return style;
        },
        mysrc() {
            let mysrc = this.src;
            if (!mysrc) {
                return mysrc;
            }
            mysrc = mysrc.replace(
                "phvgt0dwy.bkt.clouddn.com",
                "qiniuimage.neoclub.cn"
            );
            mysrc = mysrc.replace(
                "qiniuimgh5.neoclub.cn",
                "qiniuimage.neoclub.cn"
            );
            /* mysrc = mysrc.replace(
                'xiaoredpic.neoclub.cn',
                'xiaored.oss-cn-hangzhou.aliyuncs.com',
            ) */

            if (
                mysrc.indexOf("qiniuimage.neoclub.cn") > -1 ||
                mysrc.indexOf("qiniuimgh5.neoclub.cn") > -1 ||
                mysrc.indexOf("qiniubackend.neoclub.cn") > -1 ||
                mysrc.indexOf("qiniubackendgloab.neoclub.cn") > -1 ||
                mysrc.indexOf("qiniubackendh5.neoclub.cn") > -1
            ) {
                // mysrc = mysrc.split('?')[0] + '?imageView2/2/w/360/format/png'
                mysrc = mysrc.split("?")[0] + "?imageView2/2/w/360";
            } else {
                // mysrc =
                // 	mysrc.split('?')[0] +
                // 	'?x-oss-process=image/format,png/resize,w_360'
                mysrc =
                    mysrc.split("?")[0] + "?x-oss-process=image/resize,w_360";
            }
            if (mysrc.indexOf(".gif") > -1) {
                mysrc = mysrc.split("?")[0];
            }

            mysrc = mysrc.replace("http://", "https://");
            mysrc = mysrc.replace(
                "qiniuimage.neoclub.cn",
                "qiniuimgh5.neoclub.cn"
            );
            mysrc = mysrc.replace(
                "qiniubackend.neoclub.cn",
                "qiniubackendh5.neoclub.cn"
            );
            mysrc = mysrc.replace(
                "qiniubackendgloab.neoclub.cn",
                "qiniubackendh5.neoclub.cn"
            );
            mysrc = mysrc.replace(
                "xiaoredpic.neoclub.cn",
                "xiaoredpics.neoclub.cn"
            );

            return mysrc;
        }
    },
    methods: {
        serchImg(){
            this.$emit('serchImg',this.keyValue)
        }
    }
};
</script>

<style scoped>
.image-container {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.ipt {
  width: 50%;
}
</style>
